<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyWord" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData">查询</el-button>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/changeListMes',query: { callback:getList } }">
                    <el-button type="primary">新建</el-button>
                </router-link>
                <el-popover
                    placement="left"
                    trigger="hover">
                    <el-tree :load="loadNode" :props="defaultProps" lazy @node-click="handleNodeClick"></el-tree>
                    <el-button slot="reference" class="rightPos">文件目录</el-button>
                </el-popover>
            </div>
            <el-table :data="tableData">
                <el-table-column type="index" width="50"/>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="文件原名">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/documentDetail',
                                        query: { id:scope.row.id }}">
                            <el-button type="text">{{scope.row.title}}</el-button>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="文档编码" prop="size"></el-table-column>
                <el-table-column label="状态" prop="status">
                    <template slot-scope="scope">
                        {{ scope.row.status | tableVal(documentStatus) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="文档目录" prop="version"></el-table-column> -->
                <el-table-column label="创建人" prop="createUser"></el-table-column>
                <el-table-column label="上传时间" prop="createTime"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/changeListMes',
                            query: { message:scope.row,type:'edit',callback:getList } }">
                            <el-button type="text">修改</el-button>
                        </router-link>
                        <el-button type="text" @click="downloadFile(scope.row)">下载</el-button>
                        <el-button v-w-role="'ITSM-0070'" class="table-del-btn" type="text" @click="deleteRole(scope.row.id)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination 
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </el-card>
        
    </div>
</template>

<script>

    import services from "./event.service";
    import commonService from "../../services/common.service";
    export default {
        data: function () {
            return {
                form:{
                    keyWord:'',
                    pageIndex:1,
                    pageSize:10
                },
                tableData:[],
                total:5,
                defaultProps: {
                    label: 'title',
                    isLeaf: 'hasChildren',
                },
                options: [
                    {
                        id: '0',
                        cname: '新建'
                    }, {
                        id: '1',
                        cname: '待审核'
                    }, {
                        id: '-2',
                        cname: '审核不通过'
                    }, {
                        id: '2',
                        cname: '发布'
                    }, {
                        id: '-3',
                        cname: '废止'
                    }
                ],
            }
        },
        created(){
            this.getList();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            documentStatus(){
                return this.dictionary.document_status
            }
        },
        methods: {
            loadData(){
                this.form.pageIndex = 1;
                this.getList();
            },
            getList(){
                services.searchDoc(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            deleteRole(id){//删除目录信息
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.delDoc({"id":id}).then(res => {
                        this.$message.success("成功删除!");
                        this.getList();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            loadNode(node, resolve) {
                if (node.level === 0) {//加载最外层的目录
                    services.getNoPageDirectoryList({"parentId":'0'}).then(res => {
                        res.forEach(item => {
                            item.hasChildren = !item.hasChildren;
                        });
                        if(res[0]){
                            return resolve(res);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }else{//加载下级目录
                    services.getNoPageDirectoryList({"parentId":node.data.id}).then(res => {
                        res.forEach(item => {
                            item.hasChildren = !item.hasChildren;
                        });
                        if(res[0]){
                            return resolve(res);
                        }else{
                            return resolve([]);
                        }
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                }
            },
            handleNodeClick(data){
                services.getDocById({"dirId":data.id,"pageIndex":this.form.pageIndex,"pageSize":this.form.pageSize}).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            downloadFile(data){//下载文件
                window.open(data.docUrl);
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.getList();
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.getList();
            },
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rightPos{
        position: absolute;
        right: 50px;
        width: 100px;
    }
</style>
